"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _Map = _interopRequireDefault(require("../../../../atoms/Map"));
var _CallToAction = _interopRequireDefault(require("../../../../molecules/CallToAction"));
var _LocationBase = _interopRequireDefault(require("../LocationBase/LocationBase"));
var LocationsV2TopMap = function LocationsV2TopMap(_ref) {
  var locations = _ref.locations,
    verticalAlign = _ref.verticalAlign,
    horizontalAlign = _ref.horizontalAlign;
  var _locations$ = locations[0],
    ctas = _locations$.ctas,
    _locations$$name = _locations$.name,
    name = _locations$$name === void 0 ? undefined : _locations$$name,
    email = _locations$.email,
    street = _locations$.street,
    city = _locations$.city,
    state = _locations$.state,
    zipCode = _locations$.zip_code,
    country = _locations$.country,
    phoneNumber = _locations$.phone_number,
    hours = _locations$.hours;
  var address = {
    street: street,
    city: city,
    state: state,
    zip: zipCode,
    country: country
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    columns: "2",
    verticalAlign: verticalAlign,
    textAlign: horizontalAlign,
    stackable: true
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement(_Map["default"], {
    address: address
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    as: "h4",
    className: "location-collection-header"
  }, name || city), /*#__PURE__*/_react["default"].createElement(_LocationBase["default"], {
    address: address,
    email: email,
    phoneNumber: phoneNumber,
    hours: hours
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '1rem 0',
      display: 'flex',
      justifyContent: 'space-around'
    }
  }, ctas ? ctas.map(function (cta) {
    return /*#__PURE__*/_react["default"].createElement(_CallToAction["default"], (0, _extends2["default"])({}, cta, {
      size: "large"
    }));
  }) : null));
};
var _default = LocationsV2TopMap;
exports["default"] = _default;